import { createSlice } from '@reduxjs/toolkit';

// Update the empty state to include image_json
export const DomainEmptyState = {
  image_url: null,
  image_json: null, // Add this to store the parsed JSON
};

export const domainSlice = createSlice({
  name: 'domain',
  initialState: DomainEmptyState,
  reducers: {
    updateDomain: (state, action) => {
      // Update state with the new structure
      return {
        ...state,
        image_url: action.payload.image_url,
        image_json: action.payload.image_json,
      };
    },
  },
});

export const { updateDomain } = domainSlice.actions;
